export default class Base64 {
    static encode(...parts) {
        return new Promise(resolve => {
            const reader = new FileReader();
            reader.onload = () => {
                const offset = reader.result.indexOf(',') + 1;
                resolve(reader.result.slice(offset));
            };
            reader.readAsDataURL(new Blob(parts));
        });
    }

    static decode(text, charset) {
        return fetch(`data:text/plain;charset=${charset};base64,` + text).then(response => response.text());
    }

    static decodeAsBlob(text, type = 'text/plain;charset=UTF-8') {
        return fetch(`data:${type};base64,` + text).then(response => response.blob());
    }
}
